import { createFileRoute } from '@tanstack/react-router'
import { CopilotChat } from '@/features/admin/copilot-chat'

interface CopilotChatSearch {
  session?: string
}

export const Route = createFileRoute('/_authenticated/admin/copilot-chat')({
  component: CopilotChat,
  validateSearch: (search: Record<string, unknown>): CopilotChatSearch => ({
    session: typeof search.session === 'string' ? search.session : undefined,
  }),
})
